import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  constructor(private router: Router) {
    // A inicialização básica já é feita no ga.js incluído no index.html

    // Ouve as mudanças de rota no Angular para reportar o page_view correto ao GA4
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      try {
        if (typeof window.gtag === 'function') {
          // Enviar a view para o GA com o percurso dinâmico
          window.gtag('config', 'G-02G355RSS6', {
            page_path: event.urlAfterRedirects,
          });
        }
      } catch (e) {}
    });
  }

  /**
   * Envia um evento genérico para o GA4
   * @param eventName Nome do evento (ex: 'generate_lead', 'purchase')
   * @param params Parâmetros do evento
   */
  public trackEvent(eventName: string, params?: object): void {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      } else {
        // console.warn(`[GA4] gtag não disponível. Evento '${eventName}' não enviado.`);
      }
    } catch (error) {
      // console.error(`[GA4] Erro ao enviar evento '${eventName}':`, error);
    }
  }

  /**
   * Track view_item - Visualização de produto/seguro
   */
  public trackViewItem(itemName: string, itemId: string, value: number = 0): void {
    this.trackEvent('view_item', {
      currency: 'EUR',
      value: value,
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          item_category: 'insurance',
        },
      ],
    });
  }

  /**
   * Track add_to_cart - Utilizador inicia simulação
   */
  public trackAddToCart(itemName: string, itemId: string, value: number = 0): void {
    this.trackEvent('add_to_cart', {
      currency: 'EUR',
      value: value,
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          item_category: 'insurance',
        },
      ],
    });
  }

  /**
   * Track purchase - Apólice subscrita/comprada
   */
  public trackPurchase(transactionId: string, value: number, itemName: string, itemId: string): void {
    this.trackEvent('purchase', {
      transaction_id: transactionId,
      value: value,
      currency: 'EUR',
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          item_category: 'insurance',
        },
      ],
    });
  }

  /**
   * Track generate_lead - Pedido de contacto ou início de processo
   */
  public trackLead(origin: string): void {
    this.trackEvent('generate_lead', {
      event_category: 'engagement',
      event_label: origin,
    });
  }

  /**
   * Track sign_up - Registo de utilizador concluído
   */
  public trackSignUp(method: string = 'email'): void {
    this.trackEvent('sign_up', {
      method: method,
    });
  }

  /**
   * Track search - Pesquisa interna
   */
  public trackSearch(searchTerm: string): void {
    this.trackEvent('search', {
      search_term: searchTerm,
    });
  }
}
